import type { RefObject } from 'react';
import type { HeadingRef } from '../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../util/core-transition-component';

interface LocationItemRefs {
  elementRef?: RefObject<HTMLElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
  headingRef?: RefObject<HeadingRef | null>;
  lineRef?: RefObject<HTMLSpanElement | null>;
  index?: number;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { headingRef, lineRef, index }: LocationItemRefs,
): void {
  const title = findTransitionController(headingRef);

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, (index || 0) * 0.05);
  }

  if (lineRef?.current) {
    timeline.fromTo(
      lineRef.current,
      { scaleX: 0, transformOrigin: 'left center' },
      { duration: 1, ease: 'Quad.easeInOut', scaleX: 1 },
    );
  }
}

export function setupTransitionOutTimeline(): void {}

export function setupMouseEnterTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef, headingRef }: LocationItemRefs,
): void {
  if (backgroundRef?.current) {
    timeline.fromTo(
      backgroundRef.current,
      { scaleY: 0 },
      { duration: 0.4, ease: 'Expo.easeOut', scaleY: 1 },
    );
  }

  if (headingRef?.current) {
    timeline.fromTo(
      headingRef.current,
      { x: 0, y: 0 },
      { duration: 0.4, ease: 'Power2.easeOut', x: 20 },
      0,
    );
  }
}

export function setupMouseLeaveTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef, headingRef }: LocationItemRefs,
): void {
  if (backgroundRef?.current) {
    timeline.to(backgroundRef.current, { duration: 0.4, ease: 'Expo.easeOut', scaleY: 0 });
  }

  if (headingRef?.current) {
    timeline.to(headingRef.current, { duration: 0.4, ease: 'Power2.easeOut', x: 0 }, 0);
  }
}
